import React from "react";
import securityImage from "../../../assets/security.jpg";
import { Link } from "react-router-dom";

const EnsureSecurity = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="pbo-ensure-security-wrapper">
      <div className="security-details">
        <div className="row align-items-center justify-content-between">
          <div className="col-12 col-md-6 col-lg-8 col-xl-6">
            <div className="partnership__infos">
              <h2>How We Ensure Data Security in Project-Based Outsourcing</h2>
              <p className="fs-lead my-4">
                We maintain stringent security protocols when handling
                outsourced projects. Our teams operate under strict NDAs and
                data security agreements. We use secure communication channels,
                encrypted storage, and regular security audits to ensure data
                integrity and confidentiality throughout the project lifecycle.
              </p>
              <div className="mt-10x">
                <Link
                  to="/contact-us"
                  className="link-btn btn link-btn--primary"
                  onClick={scrollHeader}
                >
                  <span>Contact Us</span>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div
              className="justify-content-center d-flex"
              style={{ position: "relative", opacity: 1, transform: "none" }}
            >
              <img src={securityImage} alt="security" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnsureSecurity;
